import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Autocomplete, TextField, CircularProgress } from "@mui/material";
import { getAllCategories } from "../../services/catalogServices";

const CategorySelector = ({ onCategoryChange, value, fullWidth }) => {
    const [open, setOpen] = useState(false);
    const [options, setOptions] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        let active = true;

        if (!open) {
            return undefined;
        }

        (async () => {
            setLoading(true);
            try {
                const response = await getAllCategories();
                // Assumiamo che response sia un array di oggetti { categoryId, descrizione } o simile
                // In GestioneProdotti viene mappato in { value: categoryId, label: descrizione }
                if (active && response) {
                    const mapped = response.map(cat => ({
                        id: cat.categoryId,
                        label: cat.nome
                    }));
                    setOptions(mapped);
                }
            } catch (error) {
                console.error("Errore nel caricamento delle categorie:", error);
            } finally {
                setLoading(false);
            }
        })();

        return () => {
            active = false;
        };
    }, [open]);

    return (
        <Autocomplete
            id="category-selector"
            size="small"
            sx={{ width: fullWidth ? "100%" : 180 }}
            open={open}
            onOpen={() => setOpen(true)}
            onClose={() => setOpen(false)}
            isOptionEqualToValue={(option, selected) => option.id === selected.id}
            getOptionLabel={(option) => option.label || ""}
            options={options}
            loading={loading}
            value={value}
            onChange={(event, newValue) => {
                onCategoryChange(newValue);
            }}
            renderInput={(params) => (
                <TextField
                    {...params}
                    placeholder="Filtra per categoria..."
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                            <React.Fragment>
                                {loading ? <CircularProgress color="inherit" size={16} /> : null}
                                {params.InputProps.endAdornment}
                            </React.Fragment>
                        ),
                    }}
                    sx={{
                        "& .MuiOutlinedInput-root": {
                            fontSize: "13px",
                            height: "36px",
                            backgroundColor: "#f8fafc",
                            borderRadius: "10px",
                            "& fieldset": { borderColor: "#e2e8f0" },
                            "&:hover fieldset": { borderColor: "#cbd5e1" },
                            "&.Mui-focused fieldset": { borderColor: "#0b3d87" }
                        },
                        "& .MuiOutlinedInput-input": {
                            padding: "0 12px !important"
                        }
                    }}
                />
            )}
        />
    );
};

CategorySelector.propTypes = {
    onCategoryChange: PropTypes.func.isRequired,
    value: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        label: PropTypes.string,
    }),
    fullWidth: PropTypes.bool,
};

export default CategorySelector;
